import React from 'react';
import { Badge, BadgeSize, BadgeVariant } from '@usepepper/ui/atoms/badge';
import { createStyles } from '@/contexts/theme-context';
import { formatCurrency, roundMicrosToNearestWholeCent } from '@/utils/money';
import { ItemImage } from '@usepepper/ui/atoms/item-image';
import { ListItem } from '@usepepper/ui/molecules/list-item';
import { Order_Invoice_Line_Items } from '@/types';
import { Spacing } from '@usepepper/sprout-kit';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

export const InvoiceLineItem = ({
  invoiceCurrencyCode,
  item,
}: {
  invoiceCurrencyCode: string;
  item: Order_Invoice_Line_Items;
}) => {
  const [styles, theme] = useStyles();

  const itemName = item.item_name ?? item.item_code;
  const quantity = item.ship_quantity ?? 1;
  const packUnit =
    item.order_erp_unit_of_measure ?? item.ship_erp_unit_of_measure;
  const currencyCode = invoiceCurrencyCode;

  const unitPriceMicros = item.unit_price_in_micros ?? 0;

  const price = formatCurrency(unitPriceMicros, currencyCode);
  const totalPrice = formatCurrency(
    roundMicrosToNearestWholeCent(unitPriceMicros * quantity),
    currencyCode,
  );

  const imageWithQuantity = (
    <ItemImage
      alt={itemName}
      badge={
        <Badge
          label={quantity.toString()}
          size={BadgeSize.MEDIUM}
          variant={BadgeVariant.ELEVATED}
        />
      }
      imageURLs={item.variant_pack?.item?.photo_url_list ?? []}
      size={Spacing.SPACE_3XLARGE}
    />
  );

  const lineItemSummary = (
    <View style={styles.flexEnd}>
      <Typography color={theme.sk.color.text.primary} variant="paragraph-base">
        {totalPrice}
      </Typography>
      <Typography color={theme.sk.color.text.tertiary} variant="paragraph-md">
        {`${quantity}x ${price}`}
      </Typography>
    </View>
  );

  return (
    <ListItem
      leftElement={imageWithQuantity}
      rightElement={lineItemSummary}
      subtitle={packUnit}
      title={itemName}
    />
  );
};

const useStyles = createStyles(() => ({
  flexEnd: {
    alignItems: 'flex-end',
  },
}));
